// ABOUTME: Zustand store for UI state the dashboard's siblings share: the Customize sheet's tab.
// ABOUTME: Also the just-added widget, so the sheet can tell the grid which one to highlight.
import { create } from "zustand";

/** The Customize sheet's tabs. */
export const SHEET_TABS = ["Links", "Widgets", "Appearance"] as const;
export type SheetTab = (typeof SHEET_TABS)[number];

interface DashboardState {
  /** The Customize sheet's active tab; null means the sheet is closed. */
  sheetTab: SheetTab | null;
  /** Widget just installed from the Customize sheet, for the shimmer highlight.
   *  Lives here because the sheet and the dashboard are siblings, not parent
   *  and child. */
  justAddedWidget: string | null;
  openSheet: (tab: SheetTab) => void;
  closeSheet: () => void;
  setJustAddedWidget: (name: string | null) => void;
}

export const useDashboardStore = create<DashboardState>()((set) => ({
  sheetTab: null,
  justAddedWidget: null,

  openSheet: (sheetTab) => set({ sheetTab }),

  closeSheet: () => set({ sheetTab: null }),

  setJustAddedWidget: (justAddedWidget) => set({ justAddedWidget }),
}));
